import { createLucideIcon } from "lucide-react"

/**
 * X (formerly Twitter) logo as an outline icon, so it matches the stroke
 * style of the lucide icons beside it. Paths from Tabler Icons (MIT).
 */
export const XIcon = createLucideIcon("x-brand", [
  ["path", { d: "M4 4l11.733 16h4.267l-11.733 -16z", key: "x-brand-glyph" }],
  ["path", { d: "M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772", key: "x-brand-cut" }],
])
